import { Renderer } from "@unseenco/taxi";
import { isDEVMODE, viewStorage } from "../_globals";
import WknSwiper from "../modules/wkn-swiper";

export default class ArchiveEvents extends Renderer {
  initialLoad() {
    document.addEventListener("DOMContentLoaded", () => {
      window.addEventListener("load", () => this.onEnter());
    });
  }

  onEnter() {
    this.DOM = {
      form: viewStorage.current.querySelector(".FilterForm"),
      checkboxes: viewStorage.current.querySelectorAll(
        '.FilterForm input[type="checkbox"]'
      ),
      allCheckbox: viewStorage.current.querySelector(
        '.FilterForm input[type="checkbox"]#all'
      ),
      filterSelect: viewStorage.current.querySelector(".FilterForm select"),
      passedEventsSwiper: viewStorage.current.querySelector(
        ".PassedEvents .swiper"
      ),
    };

    this.initForm();
    this.initPassedEventsSwiper();
  }

  initForm() {
    this.DOM.checkboxes &&
      this.DOM.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () =>
          this.onCheckboxChange(checkbox)
        );
      });
    this.DOM.filterSelect &&
      this.DOM.filterSelect.addEventListener("change", () =>
        this.onSelectChange()
      );
  }

  initPassedEventsSwiper() {
    if (!this.DOM.passedEventsSwiper) return;

    if (isDEVMODE) console.log("Init PassedEvents swiper");

    this.passedEventsSwiperModule = new WknSwiper(this.DOM.passedEventsSwiper, {
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    });
  }

  onCheckboxChange(checkbox) {
    if (checkbox.id === "all") {
      this.DOM.checkboxes.forEach((checkbox) => (checkbox.checked = false));
      checkbox.checked = true;
    } else {
      this.DOM.allCheckbox.checked = false;
    }
    this.DOM.form.submit();
  }

  onSelectChange() {
    this.DOM.form.submit();
  }

  onLeaveCompleted() {
    this.DOM.checkboxes &&
      this.DOM.checkboxes.forEach((checkbox) =>
        checkbox.removeEventListener("change", () =>
          this.onCheckboxChange(checkbox)
        )
      );
    this.DOM.filterSelect &&
      this.DOM.filterSelect.removeEventListener("change", () =>
        this.onSelectChange()
      );

    if (this.passedEventsSwiperModule) {
      this.passedEventsSwiperModule.destroy();
    }
  }
}
